<script lang="ts" setup>
import ArrowIcon from '~/assets/icons/arrows/arrowBackLink.svg'
import AppHeader from '~/widgets/layout/AppHeader.vue'
import StickyMenu from '~/widgets/layout/StickyMenu.vue'
import AppFooter from '~/widgets/layout/AppFooter.vue'
import AppNavigation from '~/widgets/layout/account/AppNavigation.vue'
import Preloader from '~/components/ui/preloader/Preloader.vue'
import useAccountStore from '~/shared/store/modules/account'
import MainTitle from '~/components/ui/title/MainTitle.vue'
import ClearWarehousesSorting from '~/features/account/sorting-warehouses/ClearWarehousesSorting.vue'
import { useMonitorSize } from '~/composables/monitor-size'
import type { IMonitorSize } from '~/shared/interfaces/composables'

const navigationRouter = useRouter();
const route = useRoute();
const accountStore = useAccountStore();
const isPageOneOrder = ref(route.params.id);
const isMainAccountPage = computed(() => route.meta.key === 'account')
const isWarehouseSortingPage = computed(() => route.meta.key === 'sorting-warehouse')
const getAccountTitle = computed(() => {
  let title = "";

  if (!isMainAccountPage.value) {
    const currentPage = accountStore.accountNavigationList.find(
      (page) => page.value == route.meta.key
    );
    title = currentPage?.name ?? "";
  }

  return title;
});
let sizes: IMonitorSize | null = useMonitorSize()

navigationRouter.afterEach((to)=>{
  isPageOneOrder.value = to.params.id
})
</script>

<template>
  <div class="account app-wrap">
     <AppHeader />
    <main class="main">
      <div class="container account-wrapper">
        <AppNavigation :is-main-account-page="isMainAccountPage" />
        <div
          class="account-content"
          :class="!isMainAccountPage && 'account-content_full-width'"
          >
          <div class="account-content__title">
            <NuxtLink v-if="!isMainAccountPage && !isPageOneOrder" to="/account">
              <ArrowIcon />
              Мой профиль
            </NuxtLink>
            <MainTitle v-if="!isPageOneOrder || !sizes.isMobile" :text="getAccountTitle"
              :class="isWarehouseSortingPage && 'sorting-title'" size="s">
              <ClearWarehousesSorting v-if="isWarehouseSortingPage" />
            </MainTitle>
          </div>
          <slot />
        </div>
      </div>
    </main>
    <ClientOnly>
      <StickyMenu/>
    </ClientOnly>
    <AppFooter />
    <Preloader />
  </div>
</template>

<style lang="scss" scoped>
.account {
  .sorting-title {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    @include md-breakpoint {
      align-items: flex-start;
      gap: 16px;
    }
  }

  .main {
    padding-top: 168px;
    @include md-breakpoint {
      padding-top: 152px;
      padding-bottom: 0;
    }
  }

  &-content {
    &_full-width {
      width: 100%;
      max-width: 966px;
      margin-left: auto;

      .account-content__title {
        margin-bottom: 24px;
      }

      @include md-breakpoint {
        max-width: none;
        margin-left: 0;
      }
    }

    &__title {
      display: flex;
      gap: 8px;
      flex-direction: column;
      @include md-breakpoint {
        gap: 16px;
        padding: 0 20px;
      }

      a {
        display: none;
        @include md-breakpoint {
          display: flex;
          gap: 4px;
          align-items: center;
          @include font(14px, 20px, 500);
        }
      }
    }
  }

  &-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 135px;
    @include lg-breakpoint {
      gap: 20px;
    }
    @include md-breakpoint {
      padding: 0;
      flex-direction: column;
    }
  }
}
</style>
